import React, { useState } from 'react';
import Circular from './Circular/Circular';
import Linear from './Linear/Linear';
import './Dashboard.css';

export default function Dashboard(props){
  return (
    <section className="services-section">
      <div className="outer_dashboad">
      <div className='content-profskills'>
      <h1>Professional <span>Skills</span></h1>
        <div className="circle_cont" >
        {(props.current_section===3)&&<Circular key={1} percentage={80} text={'Problem Solving'}/>}
        {(props.current_section===3)&&<Circular key={2} percentage={84} text={'Collaboration & Teamwork'}/>}
        {(props.current_section===3)&&<Circular key={3} percentage={76} text={'Communication'}/>}
        {(props.current_section===3)&&<Circular key={4} percentage={79} text={'Leadership'}/>}
        {(props.current_section===3)&&<Circular key={5} percentage={77} text={'Time Management'}/>}
        {(props.current_section===3)&&<Circular key={6} percentage={80} text={'Adaptability'}/>}
        {(props.current_section===3)&&<Circular key={7} percentage={75} text={'Continous Learning'}/>}
        {(props.current_section===3)&&<Circular key={8} percentage={88} text={'Professionalism'}/>}
        </div>
      </div>

      <div className='content-techskills'>
        <h1>Technical <span>Skills</span></h1>
        <div className="line_cont">
        {(props.current_section===3)&&<Linear percentage={100} text={'Python'}/>} 
        {(props.current_section===3)&&<Linear percentage={95} text={'Java'}/> }
        {(props.current_section===3)&&<Linear percentage={75} text={'React Js'}/>} 
        {(props.current_section===3)&&<Linear percentage={73} text={'SQL'}/> }
        {(props.current_section===3)&&<Linear percentage={88} text={'JavaScript - HTML - CSS'}/>} 
        {(props.current_section===3)&&<Linear percentage={82} text={'Web Scraping'}/> }
        {(props.current_section===3)&&<Linear percentage={65} text={'Deep Learning'}/> }
        {(props.current_section===3)&&<Linear percentage={63} text={'NLP'}/> }
        {(props.current_section===3)&&<Linear percentage={79} text={'Artificial Intelligence'}/>}
        {(props.current_section===3)&&<Linear percentage={90} text={'Machine Learning'}/>}
        </div>        
      </div>
      </div>
    </section>
  );
}
